import React, { Fragment } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { Link, useHistory } from 'react-router-dom';

import './BreadCrumbs.scss';

interface BreadCrumbsProps {
  breadcrumbs: { name: string, link: string, reloadOnClick?: boolean }[],
  auxFunction?: () => void
}

function BreadCrumb({ breadcrumbs, auxFunction }: BreadCrumbsProps) {
  const history = useHistory();

  return (
    <div className="breadcrumbs" onClick={ auxFunction }>
      {
        _.map(breadcrumbs, (breadcrumb, index) => {
          if (breadcrumb.name !== '' && !breadcrumb.reloadOnClick){
            return (
              <Link
                key={ breadcrumb.name }
                to={ _.isEmpty(breadcrumb.link) ? '#' : breadcrumb.link }
                className={
                  classNames({
                    'breadcrumbs__single': true,
                    'breadcrumbs__single--main': index === breadcrumbs.length -1 || breadcrumbs[index + 1]?.name === ''
                  })
                }
              >{ breadcrumb.name }</Link>
            );
          } else if (breadcrumb.reloadOnClick) {
            return (
              <span
                key={ breadcrumb.name }
                onClick={ () => history.go(0) }
                className={
                  classNames({
                    'breadcrumbs__single': true,
                    'breadcrumbs__single--main': index === breadcrumbs.length -1 || breadcrumbs[index + 1]?.name === ''
                  })
                }
              >{ breadcrumb.name }</span>
            );
          } else {
            return (<Fragment key={ index } />);
          }
        })
      }
    </div>
  );
}

export default BreadCrumb;
